<template lang="pug">
  section
    b-container
      h1 {{ `Shipments ${orderId ? `for order ${orderId}` : ''}` }}
      .breadcrumbs.text-muted.small.py-3
        router-link(:to="{name: 'Order', params: { orderId } }")
          font-awesome-icon.mr-2(icon="chevron-left")
          span Back to order
      content-loader(:height="7", v-if="alert.loading")
      b-card.table-card(v-else-if="shipments && shipments.length > 0")
        b-table(hover, :items="shipments", :fields="fields", @row-clicked="openRow", sort-icon-left, sort-by="id", :sort-desc="true", responsive, borderless)
          template(v-slot:cell(compStatus)="row")
            b-badge(:variant="row.item.shipment_status==='completed'?'dark':'light'") {{ row.item.status }}
          template(v-slot:cell(compPrice)="row") {{ `R${parseFloat(row.item.total_amount).toFixed(2)}` }}
          template(v-slot:row-details='row')
              .container
                .row
                  .col-6
                    h4 Origin
                    p {{ row.item.address_origin.line_1 }}
                      br(v-if="row.item.address_origin.line_2")
                      | {{ row.item.address_origin.line_2 }}
                      br
                      | {{ row.item.address_origin.city }}
                      br
                      | {{ row.item.address_origin.zip }}
                  .col-6
                    h4 Destination
                    p {{ row.item.address_destination.line_1 }}
                      br(v-if="row.item.address_origin.line_2")
                      | {{ row.item.address_destination.line_2 }}
                      br
                      | {{ row.item.address_destination.city }}
                      br
                      | {{ row.item.address_destination.zip }}
      nothing(v-else="") No orders available
</template>

<script>

import { ContentLoader } from 'vue-content-loader';
import router from '@/router';
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';

export default {
  name: 'Shipments',
  components: {
    ContentLoader,
  },
  mixins: [standardMix],
  data() {
    return {
      shipments: [],
      currentPage: 1,
      polling: null,
      lastUpdate: '',
      orderId: this.$route.query.order || null,
      fields: [
        { key: 'id', label: 'Shipment', sortable: true },
        // { key: 'customer_order_id', label: 'Order', sortable: true },
        // { key: 'eta_pretty', label: 'ETA', sortable: true },
        { key: 'carrier_name', label: 'Carrier' },
        { key: 'compPrice', label: 'Cost' },
        { key: 'compStatus', label: 'Status' },
        // { key: 'actions', label: '' },
      ],
    };
  },
  computed: {
    totalRows() {
      return this.shipments.length;
    },
  },
  methods: {
    openRow(row) {
      router.push({ name: 'Shipment', params: { shipmentId: row.id } });
    },
  },
  async created() {
    try {
      this.loading();
      // const { order } = this.$route.query;
      this.shipments = await apiService.getShipments(this.orderId);
      this.clear();
    } catch (error) {
      this.error('Could not fetch shipments');
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Shipments.vue